import { useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AppOutlet from "../components/AppOutlet";
import { State } from "../reducer";

interface RequireAuthProps {
  allowedRoles: string[];
}

const RequireAuth = ({ allowedRoles }: RequireAuthProps) => {
  const user = useSelector((state: State) => state.user);
  const location = useLocation();
  // const isAllowed = allowedRoles.includes(user?.role?.toLowerCase() as string);
  const isAllowed = allowedRoles.includes(user?.role?.toLowerCase() as string);
  return isAllowed ? (
    <AppOutlet />
  ) : (
    <Navigate
      to={user.login ? "/unauthorized" : "/login"}
      state={{ from: location }}
      replace
    />
  );
};

export default RequireAuth;
